import { render, staticRenderFns } from "./SysBotaoDuplo.vue?vue&type=template&id=8e3a51d0&scoped=true"
import script from "./SysBotaoDuplo.vue?vue&type=script&setup=true&lang=js"
export * from "./SysBotaoDuplo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SysBotaoDuplo.vue?vue&type=style&index=0&id=8e3a51d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3a51d0",
  null
  
)

export default component.exports